import moment from "moment";

export const Columns = [
  {
    field: "name",
    header: "Name",
    accessor: (row) => (
      <p className="w-[10rem] capitalize">
        {row?.name || ""}
      </p>
    ),
  },

  {
    field: "allowedVehicles",
    header: "Allowed Vehicles",
    accessor: (row) => (
      <div className="flex flex-wrap gap-1 w-[12rem]">
        {(row?.allowedVehicles || []).map(
          (vehicle, index) => (
            <span
              key={index}
              className="px-2 py-1 rounded bg-gray-100 text-xs capitalize"
            >
              {vehicle}
            </span>
          )
        )}
      </div>
    ),
  },

  {
    field: "basePrice",
    header: "Base Price",
    accessor: (row) => (
      <p>
        ₹
        {row?.pricing?.basePrice ??
          0}
      </p>
    ),
  },

  {
    field: "bikePrice",
    header: "Bike / KM",
    accessor: (row) => (
      <p>
        ₹
        {row?.pricing
          ?.vehiclePerKmPrice
          ?.bike ?? 0}
      </p>
    ),
  },

  {
    field: "vanPrice",
    header: "Van / KM",
    accessor: (row) => (
      <p>
        ₹
        {row?.pricing
          ?.vehiclePerKmPrice
          ?.van ?? 0}
      </p>
    ),
  },

  {
    field: "truckPrice",
    header: "Truck / KM",
    accessor: (row) => (
      <p>
        ₹
        {row?.pricing
          ?.vehiclePerKmPrice
          ?.truck ?? 0}
      </p>
    ),
  },

  {
    field: "anyPrice",
    header: "Any / KM",
    accessor: (row) => (
      <p>
        ₹
        {row?.pricing
          ?.vehiclePerKmPrice
          ?.any ?? 0}
      </p>
    ),
  },

  {
    field: "weightCharge",
    header: "Weight Charge",
    accessor: (row) => (
      <p>
        ₹
        {row?.pricing?.weightCharge ??
          0}
      </p>
    ),
  },

  {
    field: "weightRange",
    header: "Weight Range",
    accessor: (row) => (
      <p className="w-[10rem]">
        {row?.minWeight ?? 0} g -{" "}
        {row?.maxWeight ?? 0} g
      </p>
    ),
  },

  {
    field: "isActive",
    header: "Status",
    accessor: (row) => (
      <span
        className={`px-2 py-1 rounded text-xs font-medium ${
          row?.isActive
            ? "bg-green-100 text-green-600"
            : "bg-red-100 text-red-600"
        }`}
      >
        {row?.isActive
          ? "Active"
          : "Inactive"}
      </span>
    ),
  },

  {
    field: "createdAt",
    header: "Created At",
    accessor: (row) => (
      <p className="w-[10rem]">
        {moment(row?.createdAt)
          .utc()
          .format(
            "DD MMM YYYY hh:mm A"
          )}
      </p>
    ),
  },
];

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",

  options: [
    {
      name: "Descending",
      code: "desc",
    },

    {
      name: "Ascending",
      code: "asc",
    },
  ],
};

export const filters = [
  {
    filterType: "Status",

    inputName: "isActive",

    options: [
      {
        name: "Active",
        code: true,
      },

      {
        name: "Inactive",
        code: false,
      },
    ],
  },
];